import { useTheme } from '@mui/material';
import { useId } from 'react';

interface GenericListIllustrationProps {
  width?: number | string;
  height?: number | string;
}

const GenericListIllustration = ({ width = 130, height = 120 }: GenericListIllustrationProps) => {
  const { palette } = useTheme();
  const placeholderClipId = `empty-list-illustration-${useId().replaceAll(':', '')}`;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 148 155"
      fill="none"
      style={{ display: 'block' }}
    >
      <ellipse
        cx="74"
        cy="140"
        rx="56"
        ry="9"
        stroke={palette.divider}
        strokeWidth="1.5"
        strokeDasharray="4 4"
      />
      <rect
        x="24"
        y="4"
        width="88"
        height="110"
        rx="10"
        fill={palette.background.paper}
        stroke={palette.divider}
        strokeWidth="1.5"
      />
      <clipPath id={placeholderClipId}>
        <rect x="34" y="14" width="68" height="48" rx="4" />
      </clipPath>
      <g clipPath={`url(#${placeholderClipId})`}>
        <rect x="34" y="14" width="68" height="48" fill={palette.action.hover} />
        <circle cx="48" cy="26" r="6" fill={palette.action.disabled} />
        <path d="M34 60 L52 40 L64 52 L78 34 L102 60 Z" fill={palette.action.disabled} />
      </g>
      <rect x="34" y="74" width="68" height="6" rx="3" fill={palette.divider} />
      <rect x="34" y="86" width="46" height="6" rx="3" fill={palette.divider} />
      <circle
        cx="100"
        cy="114"
        r="16"
        fill={palette.background.paper}
        stroke={palette.divider}
        strokeWidth="1.5"
      />
      <rect x="98" y="106" width="4" height="16" rx="2" fill={palette.text.secondary} />
      <rect x="92" y="112" width="16" height="4" rx="2" fill={palette.text.secondary} />
    </svg>
  );
};

export default GenericListIllustration;
